import React, { useEffect, useRef } from "react"
import Img from "gatsby-image"
import classnames from "classnames/bind"
import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
// Style
import imageStyle from "../../style/components/projects/image.module.scss"

function BlockFullImage(props) {
  const imageSelfRef = useRef(null)

  useEffect(() => {
    const imageSelf = imageSelfRef.current.children
    const imageWrapper = imageSelfRef.current

    // parallax effects
    gsap.timeline().to(imageSelf, {
      ease: "none",
      scrollTrigger: {
        id: "parallaxWideImage",
        trigger: imageWrapper,
        start: "top center",
        end: "bottom top",
        scrub: true,
        markers: false,
      },
      yPercent: -20,
    })

    //* 需要重新refresh，不然受到pageTransition的影響，scrollTrigger star end的位置會跑掉
    ScrollTrigger.refresh()

    return () => {
      if (ScrollTrigger.getById("parallaxWideImage")) {
        ScrollTrigger.getById("parallaxWideImage").kill()
      }
    }
  }, [])

  return pug`
    div.blocks_fullImage.pt-16.text-center(className=classnames(imageStyle.wrapper,'md:pt-24',props.className))
      div.bgImage_Wrapper(className=imageStyle.fullImage_wrapper ref=imageSelfRef)
        Img.bgImage(fluid=props.image_url alt=props.image_alt style={
          position: 'absolute',
          width: '100%',
          top: '0',
          left: '0',})
      p(className='md:text-base').mt-3.txt-caption.text-sm=props.image_alt
  `
}

function BlockWideImage(props) {
  return pug`
    div.blocks_wideImage.pt-8.text-center(className=classnames(imageStyle.wideImage_wrapper,'md:pt-16',props.className))
      div(className=classnames(imageStyle.wideImage,props.className))
        Img(fluid=props.image_url alt=props.image_alt)
        p(className='md:text-base').mt-3.txt-caption.text-sm=props.image_alt
  `
}

export { BlockFullImage, BlockWideImage }
